import { Quadbox } from "./quadbox";
import quadboxLayout from "./quadboxLayout";

export default {
  view: Quadbox,
  layoutDetails: quadboxLayout
};